import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import {
  confirmationRequest,
  addChannel,
  setPageTitle,
  fetchChannels,
  cloneChannel,
  addUserReport,
  bulkUpdateRequest,
  bulkUpdateChannel,
} from "signoxe/actions";
import { CHANNELS_RESOURCE } from "signoxe/api/resources";
import { AddSaveCancelWidget, Page, ChannelList } from "signoxe/components";
import Box from "signoxe/components/layout/Box";
import { EmptyMessage } from "signoxe/components/widgets";
import {
  getChannels,
  getProfile,
  getFilteredChannels,
} from "signoxe/selectors";
import { searchStrFromRouterLocation } from "signoxe/utils/router";
import { SearchFilterBar } from "../../components/widgets";
import { callOnEnter } from "signoxe/utils/eventHelpers";
import { Link } from "react-router-dom/es";
import DeviceAddSaveCancelWidget from "../../components/widgets/DeviceAddSaveCancelWidget";
import Dropdown, {
  DropdownContent,
  DropdownTrigger,
} from "react-simple-dropdown";
import './style.scss';

class ChannelsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectAll: false,
      selection: [],
      editing: false,
      showPopup: false,
      error: null,
      isLoading: false,
      toggleSearchBar: false,
      showMobileMenu: true,
      keys: [],
      reportActivityStatus:
        this.props.profile &&
        this.props.profile.features &&
        this.props.profile.features.record_user_activity,
    };
  }
  static propTypes = {
    profile: PropTypes.array.isRequired,
    channels: PropTypes.array.isRequired,
    addUserReport: PropTypes.func.isRequired,
    fetchChannels: PropTypes.func.isRequired,
    addChannel: PropTypes.func.isRequired,
    confirmationRequest: PropTypes.func.isRequired,
    cloneChannel: PropTypes.func.isRequired,
    setPageTitle: PropTypes.func.isRequired,
    isFetching: PropTypes.bool.isRequired,
    filteredChannels: PropTypes.array.isRequired,
    searchString: PropTypes.string,
    bulkUpdateRequest: PropTypes.func.isRequired,
    bulkUpdateChannel: PropTypes.func.isRequired,


  };

  handleBulkUpdateChannels = (channel) =>
  this.props.bulkUpdateChannel(channel);

  toggleSelection = (key, shift, row) => {
    // start off with the existing state
    let selection = [...this.state.selection];
    const keyIndex = selection.indexOf(key);

    // check to see if the key exists
    if (keyIndex >= 0) {
      // it does exist so we will remove it using destructing
      selection = [
        ...selection.slice(0, keyIndex),
        ...selection.slice(keyIndex + 1),
      ];
    } else {
      // it does not exist so add it
      selection.push(key);
    }
    // update the state
    this.setState({ selection });
  };

  rowFn = (state, rowInfo, column, instance) => {
    const { selection } = this.state;

    return {
      onClick: (e, handleOriginal) => {
        console.log("It was in this row:", rowInfo);

        // IMPORTANT! React-Table uses onClick internally to trigger
        // events like expanding SubComponents and pivots.
        // By default a custom 'onClick' handler will override this functionality.
        // If you want to fire the original onClick handler, call the
        // 'handleOriginal' function.
        if (handleOriginal) {
          handleOriginal();
        }
      },
      style: {
        background:
          rowInfo &&
          selection.includes(`select-${rowInfo.original.id}`) &&
          "#ccd1d1 ",
      },
    };
  };

  quickSave = () => {
    var array = [];
    for (const name in this.state.keys) {
      array.push(this.state.keys[name]["original"]);
    }
    // console.log("array edit:", array);
    this.handleBulkUpdateChannels(array);
  };

  renderEditable = (cellInfo) => {
    return (
      <div>
        {this.state.editing ? (
          <input
            style={{ backgroundColor: "transparent" }}
            type="text"
            value={
              this.props.filteredChannels[cellInfo.index][cellInfo.column.id]
            }
            onChange={(e) => {
              const data = [...this.props.filteredChannels];
              let editedData = [...this.state.keys];
              data[cellInfo.index][cellInfo.column.id] = e.target.value;
              editedData.push(cellInfo);
              this.setState({ keys: editedData });
              this.quickSave;
            }}
            onBlur={(e) => {
              this.quickSave;
            }}
            onKeyDown={callOnEnter(this.quickSave)}
          />
        ) : (
          <Link
            to={`/channels/${cellInfo.original.id}`}
            className="is-cursor text-dark"
            suppressContentEditableWarning
            dangerouslySetInnerHTML={{
              __html:
                this.props.filteredChannels[cellInfo.index][cellInfo.column.id],
            }}
          />
        )}
      </div>
    );
  };


  isSelected = (key) => {
    return this.state.selection.includes(`select-${key}`);
  };

  toggleAll = () => {
    const { key } = this.props;
    const selectAll = !this.state.selectAll;
    const selection = [];

    if (selectAll) {
      // we need to get at the internals of ReactTable
      const wrappedInstance = this.checkboxTable.getWrappedInstance();
      // the 'sortedData' property contains the currently accessible records based on the filter and sort
      const currentRecords = wrappedInstance.getResolvedState().sortedData;
      // we just push all the IDs onto the selection array
      currentRecords.forEach((item) => {
        console.log("item", item._original['id'])
        selection.push(`select-${item._original['id']}`);
      });

    }
  
    this.setState({ selectAll, selection });
    console.log("slection", this.state.selection)
  };

  handleAddChannel = (name) => this.props.addChannel({ name });

  componentDidMount() {
    this.props.fetchChannels();
    this.props.setPageTitle("Channels");
  }

  handleCloneChannel = (channel) => this.props.cloneChannel(channel);

  handleDeleteChannel = (channel) => {
    const { profile } = this.props;
    if (this.state.reportActivityStatus) {
      this.props.addUserReport({
        user: profile.id,
        action_type: "Delete",
        activity: `deleted (or attempt to delete) channel named  ${channel.name}`,
      });
    }
    this.props.confirmationRequest(
      "Deleting Channel",
      `Deleting the channel "${channel.name}" is permanent and cannot be undone.`,
      "DELETE",
      CHANNELS_RESOURCE,
      channel.id
    );
  };
  handleSearch = (searchValue) => {
    this.props.history.replace({
      search: `?search=${searchValue}`,
    });
  };
  onToggleEdit = () => {
    this.setState({ editing: !this.state.editing });
    this.setState({ selection: [] });
    this.setState({ showPopup: !this.state.showPopup });

  };
  onToggleBack = () => {
    this.setState({ toggleSearchBar: false });
    this.setState({ showMobileMenu: true });
  };

  resetViews = () => {
    this.setState({ selection: [] });
    this.setState({ showPopup: false });
  };

  deleteAllSelected = () => {
    var arrayStr = this.state.selection.map(function (x) {
      return x.replace("select-", "");
    });

    var arrToNum = arrayStr.map((str) => {
      return Number(str);
    });

    this.setState({ isLoading: true });

    // let new_arrray = this.props.groups;
    // var newr = new_arrray.filter((e) => !arrToNum.find((num) => e.id === num));
    console.log("arrToNum", arrToNum)
    // this.handleBulkDeletePlaylists(arrToNum)

    this.props.bulkUpdateRequest(
      "Bulk Channel Delete",
      `Confirm deleting of "${arrToNum.length}" channel(s), cannot be undone!.`,
      "DELETE",
      CHANNELS_RESOURCE,
      arrToNum.length,
      arrToNum
    );
    
    this.setState({ isLoading: false });
    this.setState({ showPopup: false });
    this.setState({ selection: [] });
  };

  onToggleCreateChannel = () => {
    this.setState({ toggleSearchBar: true });
    this.setState({ showMobileMenu: false });
  };


  render() {
    const {
      error,
      isLoading,
      editing,
      toggleSearchBar,
      showMobileMenu,
      selectAll,
    } = this.state;
    const profile = this.props.profile
    const allowed_pages = profile && this.props.profile.allowed_pages
    const isNotAllowed = profile && allowed_pages && this.props.profile.allowed_pages.channels_page

    return (
      <Page isNotAllowed={isNotAllowed}  className="channels-page">
         {this.state.selection.length != 0 && (
          <div id="note">
            <div>
              <h6>
                {this.state.selection && this.state.selection.length}
                {this.state.selection.length > 1
                  ? " Items Selected"
                  : " Item Selected"}
              </h6>
            </div>
            <div className="btns">
              <button className="btn1" onClick={this.resetViews}>
                {" "}
                <i className="fas fa-eye-slash"></i> RESET VIEWS
              </button>
              <button className="btn2" onClick={this.deleteAllSelected}>
                {" "}
                <i className="fas fa-trash"></i> DELETE
              </button>
            </div>
          </div>
        )}
        
        <div className="margin-bottom">
              <div class=" searchbar flex flex-jc-sb mb-3 ">
                {toggleSearchBar === false ? (
                  <SearchFilterBar
                    className="input-group-2"
                    placeholder="Search Channel"
                    queryString={this.props.searchString}
                    onQueryChange={this.handleSearch}
                  />
                ) : (
                  <div className="">
                      <DeviceAddSaveCancelWidget
                        addLabel="Add Channel"
                        onToggle={this.onToggleBack}
                        onSave={this.handleAddChannel}
                      />
                    
                  </div>
                )}

                {showMobileMenu === true && (
                  <div className="hide-for-desktop">
                    <Dropdown>
                      <DropdownTrigger>
                        <button type="button" className="button">
                          <span
                            style={{ marginRight: "5px", fontSize: "0.7rem" }}
                          >
                            Actions
                          </span>
                          <span
                            title="actions"
                            className="icon fa fa-caret-down"
                            style={{ fontSize: "1rem", color: "#fff" }}
                          ></span>
                        </button>
                      </DropdownTrigger>
                      <DropdownContent className="user-menu actions-menu card depth-1">
                        <li onClick={this.onToggleCreateChannel}>
                          Add a Channel
                        </li>
                        <li onClick={this.onToggleEdit}>
                          <i
                            class={
                              editing
                                ? "fas fa-toggle-on mr-1"
                                : "fas fa-toggle-off mr-1"
                            }
                          ></i>
                          Edit Mode
                        </li>
                      </DropdownContent>
                    </Dropdown>
                  </div>
                )}

                <div class="flex flex-ai-c hide-for-mobile">
                  <button
                    class="button ctb mr--sm"
                    onClick={this.onToggleCreateChannel}
                  >
                    <i className="fas fa-plus mr-1"></i>
                    Create Channel
                  </button>
                  {this.props.filteredChannels.length != 0 && (
                    <button
                      className={editing ? "button btn-bg" : "button"}
                      onClick={this.onToggleEdit}
                    >
                      <i
                        class={
                          editing
                            ? "fas fa-toggle-on mr-1"
                            : "fas fa-toggle-off mr-1"
                        }
                      ></i>
                      Edit Mode{" "}
                    </button>
                  )}
                </div>
              </div>
            </div>
        
        {!this.props.isFetching && this.props.channels.length === 0 ? (
          <EmptyMessage text="No Channels. Please Add one!" />
        ) : (
          <ChannelList
            channels={this.props.filteredChannels}
            onDelete={this.handleDeleteChannel}
            onClone={this.handleCloneChannel}
            toggleSelection={this.toggleSelection}
            editing={this.state.editing}
            selectAll={this.state.selectAll}
            renderEditable={this.renderEditable}
            tableProps={this.rowFn}
            checkedIsSelected={this.isSelected}
            refKey={(r) => (this.checkboxTable = r)}
            onToggleEdit={this.onToggleEdit}
            handleToggleAll={this.toggleAll}
            />
        )}
      </Page>
    );
  }
}

export default connect(
  (state, props) => {
    const searchString = searchStrFromRouterLocation(props.location);
    return {
      searchString,
      channels: getChannels(state),
      profile: getProfile(state),
      isFetching: state.channels.isFetching,
      filteredChannels: getFilteredChannels(state, searchString),
    };
  },
  {
    confirmationRequest,
    setPageTitle,
    addChannel,
    fetchChannels,
    addUserReport,
    cloneChannel,
    bulkUpdateRequest,
    bulkUpdateChannel,
  }
)(ChannelsPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/ChannelsPage/index.js